import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimer = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.75 28C20.2393 28 25.5 27.2165 25.5 26.25C25.5 25.2835 20.2393 24.5 13.75 24.5C7.26065 24.5 2 25.2835 2 26.25C2 27.2165 7.26065 28 13.75 28Z",
			fill: "#E9E9E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5452 8.39616C20.3359 8.39616 20.1266 8.31681 19.9668 8.15812C19.6471 7.841 19.6471 7.32632 19.9668 7.0092L22.1486 4.84253C22.4682 4.52515 22.9859 4.52515 23.3055 4.84253C23.6251 5.15965 23.6251 5.67434 23.3055 5.99145L21.1237 8.15812C20.9639 8.31681 20.7546 8.39616 20.5452 8.39616Z",
			fill: "#335262"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 24.917C19.4223 24.917 23.818 20.5518 23.818 15.167C23.818 9.78222 19.4223 5.41699 13.9998 5.41699C8.57739 5.41699 4.18164 9.78222 4.18164 15.167C4.18164 20.5518 8.57739 24.917 13.9998 24.917Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.09082 15.1663C3.09082 21.1398 7.98473 25.9997 13.9999 25.9997C20.0151 25.9997 24.909 21.1398 24.909 15.1663C24.909 9.19293 20.0151 4.33301 13.9999 4.33301C7.98473 4.33301 3.09082 9.19293 3.09082 15.1663ZM5.27267 15.1663C5.27267 10.3876 9.1878 6.49967 13.9999 6.49967C18.8121 6.49967 22.7272 10.3876 22.7272 15.1663C22.7272 19.9451 18.8121 23.833 13.9999 23.833C9.1878 23.833 5.27267 19.9451 5.27267 15.1663Z",
			fill: "#335262"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2729 2.70833C11.2729 4.20162 12.4965 5.41667 14.0002 5.41667C15.504 5.41667 16.7275 4.20162 16.7275 2.70833C16.7275 1.21504 15.504 0 14.0002 0C12.4965 0 11.2729 1.21504 11.2729 2.70833ZM12.3639 2.70826C12.3639 1.81218 13.0979 1.08326 14.0002 1.08326C14.9026 1.08326 15.6366 1.81218 15.6366 2.70826C15.6366 3.60434 14.9026 4.33326 14.0002 4.33326C13.0979 4.33326 12.3639 3.60434 12.3639 2.70826Z",
			fill: "#335262"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2287 14.4005C13.6547 13.9774 18.6284 10.5703 18.6284 10.5703C18.6284 10.5703 15.1975 15.5095 14.7715 15.9325C14.3455 16.3556 13.6547 16.3556 13.2287 15.9325C12.8027 15.5095 12.8027 14.8235 13.2287 14.4005Z",
			fill: "#EF4853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 9.74967C13.6986 9.74967 13.4546 9.50714 13.4546 9.20801V8.12467C13.4546 7.82554 13.6986 7.58301 14 7.58301C14.3015 7.58301 14.5455 7.82554 14.5455 8.12467V9.20801C14.5455 9.50714 14.3015 9.74967 14 9.74967Z",
			fill: "#919191"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4546 15.1667C19.4546 14.8673 19.6988 14.625 20 14.625H21.091C21.3922 14.625 21.6364 14.8673 21.6364 15.1667C21.6364 15.4661 21.3922 15.7083 21.091 15.7083H20C19.6988 15.7083 19.4546 15.4661 19.4546 15.1667Z",
			fill: "#919191"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 20.583C14.3015 20.583 14.5455 20.8255 14.5455 21.1247V22.208C14.5455 22.5071 14.3015 22.7497 14 22.7497C13.6986 22.7497 13.4546 22.5071 13.4546 22.208V21.1247C13.4546 20.8255 13.6986 20.583 14 20.583Z",
			fill: "#919191"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.54559 15.1667C8.54559 15.4661 8.30136 15.7083 8.00013 15.7083H6.90922C6.608 15.7083 6.36377 15.4661 6.36377 15.1667C6.36377 14.8673 6.608 14.625 6.90922 14.625H8.00013C8.30136 14.625 8.54559 14.8673 8.54559 15.1667Z",
			fill: "#919191"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9117 8.07088L20.0548 4.24072C19.8418 4.02919 19.8418 3.68622 20.0548 3.47469L21.2119 2.32564C21.4249 2.11411 21.7702 2.11411 21.9833 2.32564L25.8402 6.1558C26.0532 6.36734 26.0532 6.7103 25.8402 6.92183L24.6831 8.07088C24.4701 8.28241 24.1247 8.28241 23.9117 8.07088Z",
			fill: "#919191"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45459 8.39616C7.24525 8.39616 7.03591 8.31681 6.87611 8.15812L4.69429 5.99145C4.37469 5.67434 4.37469 5.15965 4.69429 4.84253C5.0139 4.52515 5.53165 4.52515 5.85125 4.84253L8.03307 7.0092C8.35267 7.32632 8.35267 7.841 8.03307 8.15812C7.87327 8.31681 7.66393 8.39616 7.45459 8.39616Z",
			fill: "#335262"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.08823 8.07088L7.94518 4.24072C8.15819 4.02919 8.15819 3.68622 7.94518 3.47469L6.78809 2.32564C6.57508 2.11411 6.22972 2.11411 6.01671 2.32564L2.15976 6.1558C1.94675 6.36734 1.94675 6.7103 2.15976 6.92183L3.31684 8.07088C3.52985 8.28241 3.87521 8.28241 4.08823 8.07088Z",
			fill: "#919191"
		})
	]
});
const ForwardRef = forwardRef(SvgTimer);
export default ForwardRef;
